// queries.js

import { gql } from "@apollo/client";

export const GET_CLIENT_METER_SETTING_EVENTS_QUERY = gql`
  query ($clientId: Int!, $first: Int, $skip: Int, $event: String) {
    clientMeterSettingEvents(
      clientId: $clientId
      first: $first
      skip: $skip
      event: $event
    ) {
      currentPage
      hasNextPage
      hasPreviousPage
      totalPages
      totalRecords
      items {
        id
        timestamp
        event
        previousValue
        currentValue
        appUser
        clientId
      }
    }
  }
`;
